import { apiInstance } from '@/utils/axios';

export interface PricingTierInfo {
  label: string;
  monthly_price: number;
  monthly_price_cents: number;
  enrichment_credits: number;
  ai_credits: number;
  seat_limit: number | null;
}

export interface PricingInfo {
  tiers?: Partial<Record<'prospect' | 'outreach' | 'growth', PricingTierInfo> & Record<'starter' | 'standard' | 'pro', PricingTierInfo>>;
  /** @deprecated use tiers.outreach */
  standard: {
    monthly_price_per_seat?: number;
    monthly_price?: number;
    enrichment_credits?: number;
    ai_credits?: number;
    annual_price_per_seat?: number;
    ai_credits_per_seat: number;
    enrichment_credits_per_seat: number;
    features?: string[];
  };
  trial: {
    ai_credits: number;
    enrichment_credits: number;
    duration_days: number;
  };
  enrichment_packages: Array<{
    name: string;
    label: string;
    credits: number;
    price: number;
    price_cents: number;
    per_credit: string;
  }>;
  enrichment_action_costs: {
    company_reveal: number;
    email_lookup: number;
    phone_lookup: number;
    linkedin_enrichment: number;
    sales_nav_export: number;
    audience_people_search: number;
    audience_company_search: number;
    social_mention: number;
    job_posting: number;
    champion_tracking: number;
    podcast_mention: number;
    product_review: number;
  };
  ai_overage_per_million_credits: number;
  annual_discount_percent: number;
  annual_discount_label: string;
  currency: string;
  smart_dialer_addon: {
    monthly_price_per_seat: number;
  };
}

/** Get pricing information from the backend (V3 catalog). */
export const getPricingInfo = async (): Promise<PricingInfo> => {
  const response = await apiInstance.get('/public/pricing');
  return response.data.data;
};
